module.exports = {
  src: __webpack_public_path__ + "assets/images/warning-icon.2bffde2638e2ba0c.svg",
  width: 20,
  height: 20,
  toString: function() { return __webpack_public_path__ + "assets/images/warning-icon.2bffde2638e2ba0c.svg"; }
};